// extracted by css-extract-rspack-plugin
var _1 = "tJ7mWnDcqZ48ttV4";
export { _1 as "content" }
// extracted by css-extract-rspack-plugin
var _1 = "tJ7mWnDcqZ48ttV4";
export { _1 as "content" }
